import { render, staticRenderFns } from "./Appcard.vue?vue&type=template&id=544c8db0&"
import script from "./Appcard.vue?vue&type=script&lang=js&"
export * from "./Appcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports